

<template>
<div class="fullcontainer centerbg" @touchstart="onTouchStart" @touchend="onTouchEnd" style="background-image:url('res/p4/bg.jpg');">
  <!-- <keep-alive> -->
    <component :is="currentView"></component>
    <component v-show="topCurrentView" :is="topCurrentView" class="topcls" :class="topClass"></component>
   <!-- </keep-alive>   -->
   <!-- 加这个不正常 -->
   <Back2FirstPage picposcls="picpos" />
    <!-- <VrIcon picposcls="vrpos" /> -->
    <MusicIcon picposcls="musicpos" />
    <div class="xljt_conti bounce" @click="nextPage">
      <img src="res/p4/xljt.png" class="xljt" >
    </div>
</div>
</template>

<script>
import P4_1 from "./P4_1";
import P4_2 from "./P4_2";
import P4_3 from "./P4_3";
import P4_4 from "./P4_4";
import P4_5 from "./P4_5";

import Back2FirstPage from "./Back2FirstPage";
import MusicIcon from "./MusicIcon";
import VrIcon from "./VrIcon";

import {statPage} from "@/stat.js";

// import { gotoLink } from "@/d";

const pages = {
  P4_1,
  P4_2,
  P4_3,
  P4_4,
  P4_5
};

const components = Object.assign({}, pages);
Object.assign(components, { Back2FirstPage, MusicIcon, VrIcon });

export default {
  data() {
    return {
      currentView: P4_1,
      topCurrentView: null,
      topClass: "",
      allpages: null,
      currentViewIndex: 0
    };
  },

  mounted() {
    const allpages = [];
    // window.console.log(this);
    for (let key in pages) {
      let cls = components[key];
      allpages.push(cls);
    }
    this.allpages = allpages;
    this.currentViewIndex = allpages.indexOf(this.currentView);
  },

  methods: {
    onTouchStart(e) {
      this._lastY = e.changedTouches[0].clientY;
    },

    onTouchEnd(e) {
      if (this._nextIndex != undefined) {
        return;
      }
      let d = e.changedTouches[0].clientY - this._lastY;
      if (Math.abs(d) < 20) return;
      if (d < 0) {
        this.nextPage();
      } else {
        this._nextIndex =
          (this.currentViewIndex - 1 + this.allpages.length) %
          this.allpages.length;
        this._move("movedownstart");
      }
    },

    nextPage() {
      if (this._nextIndex != undefined) {
        return;
      }
      // if(this._downCount == undefined) {
      //   this._downCount = 0;
      // }
      // this._downCount++;
      // if(this._downCount>=this.allpages.length && this.currentViewIndex+1==this.allpages.length)
      // {
      //   delete this._nextIndex;
      //   return gotoLink('https://720yun.com/t/68vkuq77dql#scene_id=41418402');
      // }
      this._nextIndex = (this.currentViewIndex + 1) % this.allpages.length;
      this._move("moveupstart");
    },

    _move(startclass) {
      
      this.topClass = startclass;
      this.topCurrentView = this.allpages[this._nextIndex];
      setTimeout(() => {
        this.topClass = "moveend";
        setTimeout(() => {
          this.currentView = this.topCurrentView;
          this.topCurrentView = null;
          this.currentViewIndex = this._nextIndex;
          delete this._nextIndex;
        }, 1000);
      }, 100);

      statPage();
    }
  },

  components
};
</script>

<style lang="scss">
@import "D:/workspace/all_web/src/_cmm/css/centerbg.scss";
@import "D:/workspace/all_web/src/_cmm/css/horizontalCenterPercent.scss";

.topcls {
  position: absolute;
  // top:0;
}

.movedownstart {
  // transform: translateY(-100%);
  top: -100vh;
}
.moveupstart {
  top: 100vh;
}
.moveend {
  top: 0vh;
  transition: top 1s;
  transition-timing-function: ease-in;
}

.xljt_conti {
  position: absolute;
  width: 100%;
  height: 0.4rem;
  bottom:0;
  .xljt {
    @include horizontalCenterPercent(10%);
  }
}

</style>
